export enum PaymentDetailsTransactionTypes {
  Debit_Order = 1,
  Credit_Debit_Card = 2
}
